import { toSentenceCase } from '@noths/polaris-client-utils';

import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';
import { BrowseDataAPIFilterUID } from 'src/services/browse-data-api/constants/BrowseDataAPIFilterUID';

export const getFacetsWithSortAsAFacet = (facets: Facet[], sortOptions: SortOption[]) => {
  const sortFacet: Facet = {
    active: false,
    valueType: 'text',
    options: sortOptions.map(({ active, id, title }) => ({
      active,
      count: null,
      maxValue: null,
      minValue: null,
      pseudoActive: false,
      title: toSentenceCase(title),
      uid: id,
      value: id,
    })),
    title: 'Sort',
    type: 'single',
    key: BrowseDataAPIFilterUID.Sort,
  };

  return [sortFacet, ...facets];
};
